export default __webpack_public_path__ + "static/media/recycle.ebcfba5b.png";